import React, { useState, useEffect, useRef } from 'react'
import { useParams, Link } from 'react-router-dom'
import "../Styles/Itinerary.css"
import pdfhomeimg from "../Images/pdf-nature.jpg"
import logo from "../Images/Jayraj_logo.png"
import packageImgpdf from "../Images/pdf-tour.jpg"
import hotelImg from "../Images/hotelimg.jpg"
import vahicle from "../Images/visiting_place_world.png"
import { FaWhatsapp, FaInstagram, FaYoutube, FaFacebook, FaDownload } from 'react-icons/fa'
import api from "../Api.js"
import sanitizeHtml from "sanitize-html";
import { useNavigate } from 'react-router-dom'
import { useSearchParams } from "react-router-dom";
import noimg from "../Images/noimg.jpg"
import { useReactToPrint } from "react-to-print";
import html2pdf from "html2pdf.js";
import SafeMap from './Safemap.jsx'




function formatDate(dateString) {
    const date = new Date(dateString);

    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    // Get parts
    const dayName = days[date.getDay()];
    const day = date.getDate();
    const monthName = months[date.getMonth()];

    // Add ordinal suffix
    const getOrdinal = (n) => {
        if (n % 10 === 1 && n % 100 !== 11) return n + "st";
        if (n % 10 === 2 && n % 100 !== 12) return n + "nd";
        if (n % 10 === 3 && n % 100 !== 13) return n + "rd";
        return n + "th";
    };

    return `${dayName} ${getOrdinal(day)} ${monthName}`;
}

function calculateNights(checkIn, checkOut) {
    const inDate = new Date(checkIn);
    const outDate = new Date(checkOut);
    if (isNaN(inDate) || isNaN(outDate)) return 0;

    // Difference in milliseconds
    const diffTime = outDate - inDate;

    // Convert ms → days
    const nights = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return nights;
}

const sanitizeToText = (html) => {
    const clean = sanitizeHtml(html, { allowedTags: [], allowedAttributes: {} });
    return clean;
};

// Available Dates Component (add this before the ItineryFinal component)
const AvailableDatesSection = ({ groupData }) => {
    if (!groupData || !groupData.departure_dates) return null;

    const { departure_dates, active_months } = groupData;

    // Get today's date at midnight for comparison
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Filter only future dates
    const futureDates = departure_dates.filter(dateStr => {
        const date = new Date(dateStr + 'T00:00:00');
        return date >= today;
    });

    // If no future dates available
    if (futureDates.length === 0) {
        return (
            <div className="available-dates-wrapper">
                <div style={{ display: "flex", justifyContent: "space-between", marginTop: "30px" }}>
                    <h3 style={{ color: "#503507" }}>Available Departure Dates</h3>
                </div>
                <div className="no-dates-message" style={{
                    background: '#fef9e7',
                    border: '1px solid #f9e79f',
                    borderRadius: '8px',
                    padding: '20px',
                    textAlign: 'center',
                    color: '#7d6608'
                }}>
                    <p style={{ margin: '10px 0', fontSize: '16px' }}>
                        No upcoming departure dates available at the moment.
                    </p>
                    <p style={{ margin: '10px 0', fontSize: '14px', color: '#555' }}>
                        Please check back later for new dates.
                    </p>
                </div>
            </div>
        );
    }

    // Get active months from future dates only
    const futureActiveMonths = [...new Set(futureDates.map(date => date.substring(0, 7)))].sort();

    // Group dates by month
    const groupDatesByMonth = () => {
        const grouped = {};
        futureDates.forEach(date => {
            const month = date.substring(0, 7);
            if (!grouped[month]) {
                grouped[month] = [];
            }
            grouped[month].push(date);
        });
        return grouped;
    };

    // Format date for display
    const formatDateDisplay = (dateString) => {
        const date = new Date(dateString + 'T00:00:00');
        return date.toLocaleDateString('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    };

    // Format month for display
    const formatMonthDisplay = (monthString) => {
        const [year, month] = monthString.split('-');
        const date = new Date(year, parseInt(month) - 1, 1);
        return date.toLocaleDateString('en-US', {
            month: 'long',
            year: 'numeric'
        });
    };

    const groupedDates = groupDatesByMonth();

    return (
        <div className="available-dates-wrapper" style={{ marginTop: '30px' }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h3 style={{ color: "#503507" }}>Available Departure Dates</h3>
            </div>

            {/* Summary of available months */}
            <div style={{
                background: '#f8f6f0',
                padding: '12px 16px',
                borderRadius: '8px',
                marginBottom: '20px',
                borderLeft: '4px solid #b8860b'
            }}>
                <p style={{ marginBottom: '8px', fontWeight: '600', fontSize: '14px' }}>
                    Available in:
                </p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                    {futureActiveMonths.map(month => (
                        <span key={month} style={{
                            background: '#b8860b',
                            color: 'white',
                            padding: '4px 14px',
                            borderRadius: '20px',
                            fontSize: '13px',
                            fontWeight: '500'
                        }}>
                            {formatMonthDisplay(month)}
                        </span>
                    ))}
                </div>
            </div>

            {/* Dates grouped by month */}
            <div style={{ marginBottom: '15px' }}>
                {Object.entries(groupedDates).map(([month, dates]) => (
                    <div key={month} style={{ marginBottom: '20px' }}>
                        <h4 style={{
                            color: '#503507',
                            borderBottom: '2px solid #e8e0d5',
                            paddingBottom: '6px',
                            marginBottom: '12px',
                            fontSize: '1rem'
                        }}>
                            {formatMonthDisplay(month)}
                        </h4>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
                            gap: '10px'
                        }}>
                            {dates.map(date => {
                                const dateObj = new Date(date + 'T00:00:00');
                                const isToday = dateObj.getTime() === today.getTime();
                                const isTomorrow = dateObj.getTime() === new Date(today.getTime() + 86400000).getTime();

                                return (
                                    <div key={date} style={{
                                        background: isToday ? '#f0fff4' : isTomorrow ? '#fffcf0' : 'white',
                                        border: isToday ? '2px solid #28a745' : isTomorrow ? '2px solid #ffc107' : '1px solid #e8e0d5',
                                        borderRadius: '8px',
                                        padding: '10px 8px',
                                        textAlign: 'center',
                                        transition: 'all 0.2s ease',
                                        cursor: 'pointer',
                                        position: 'relative'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                                        e.currentTarget.style.borderColor = '#b8860b';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = 'none';
                                        if (!isToday && !isTomorrow) {
                                            e.currentTarget.style.borderColor = '#e8e0d5';
                                        }
                                    }}>
                                        <span style={{
                                            display: 'block',
                                            fontSize: '20px',
                                            fontWeight: 'bold',
                                            color: '#1a1a1a'
                                        }}>
                                            {dateObj.getDate()}
                                        </span>
                                        <span style={{
                                            display: 'block',
                                            fontSize: '11px',
                                            color: '#888',
                                            textTransform: 'uppercase',
                                            marginTop: '2px'
                                        }}>
                                            {dateObj.toLocaleDateString('en-US', { weekday: 'short' })}
                                        </span>
                                        <span style={{
                                            display: 'block',
                                            fontSize: '10px',
                                            color: '#999',
                                            marginTop: '4px'
                                        }}>
                                            {formatDateDisplay(date)}
                                        </span>
                                        {isToday && (
                                            <span style={{
                                                position: 'absolute',
                                                top: '-8px',
                                                right: '-8px',
                                                background: '#28a745',
                                                color: 'white',
                                                fontSize: '9px',
                                                padding: '2px 8px',
                                                borderRadius: '12px',
                                                fontWeight: '600'
                                            }}>
                                                Today
                                            </span>
                                        )}
                                        {isTomorrow && (
                                            <span style={{
                                                position: 'absolute',
                                                top: '-8px',
                                                right: '-8px',
                                                background: '#ffc107',
                                                color: '#333',
                                                fontSize: '9px',
                                                padding: '2px 8px',
                                                borderRadius: '12px',
                                                fontWeight: '600'
                                            }}>
                                                Tomorrow
                                            </span>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                ))}
            </div>

            {/* Stats */}
            <div style={{
                marginTop: '20px',
                padding: '12px 16px',
                background: '#fafaf8',
                borderRadius: '8px',
                display: 'flex',
                gap: '30px',
                flexWrap: 'wrap',
                border: '1px solid #e8e0d5'
            }}>
                <p style={{ margin: 0, color: '#555', fontSize: '13px' }}>
                    Total available dates: <strong style={{ color: '#503507' }}>{futureDates.length}</strong>
                </p>
                <p style={{ margin: 0, color: '#555', fontSize: '13px' }}>
                    Available months: <strong style={{ color: '#503507' }}>{futureActiveMonths.length}</strong>
                </p>
                <p style={{ margin: 0, color: '#555', fontSize: '13px' }}>
                    Earliest departure: <strong style={{ color: '#503507' }}>{formatDateDisplay(futureDates[0])}</strong>
                </p>
            </div>
        </div>
    );
};

function ItineryFinal() {


    const navigate = useNavigate();


    const [searchParams] = useSearchParams();

    const adultCount = Number(searchParams.get("adult")) || 1;
    const childCount = Number(searchParams.get("child")) || 0;
    console.log("the adult count is ", adultCount);
    console.log("the adult count is ", childCount);

    const { destinationId, custId, tourId, bookingID } = useParams();
    console.log("custId from params: ", custId)
    console.log("tourId from params: ", tourId)

    const [itinerary, setItinerary] = useState([])
    const [packages, SetPackages] = useState({})
    const [tour, setTour] = useState({})
    const [hotelDetails, setHotelDetails] = useState([])
    const [transport, setTransport] = useState({})
    const [hotelData, setHotelData] = useState({})
    const [allTransport, setAllTransport] = useState([])
    const [computedPricing, setComputedPricing] = useState({})
    const [customer, setCustomer] = useState({})
    const [img, setImg] = useState(hotelImg)
    const [hotelPrice, setHotelPrice] = useState(0)
    const [transportPrice, setTransportPrice] = useState(0)
    const [groupResponse, setGroupResponse] = useState(0);
    const [rooms, setRooms] = useState([])
    const [transportData, setTransportData] = useState([])
    //   const [finalImg, setFinalImg] = useState(hotelimg);
    const [loading, setLoading] = useState(true);
    useEffect(() => {


        // console.log("id from package overview: ", id)
        const fetchItinerary_wrt_id = async () => {
            try {
                const res = await api.get(`/destinations/${destinationId}/tours/${tourId}/itinerary/${custId}/${bookingID}`);
                console.log("the response from package itinerary: ", res.data)



                if (res.data?.success === true) {
                    setGroupResponse(res?.data?.data)
                    SetPackages(res?.data?.data?.package)
                    setItinerary(res?.data?.data?.itineraries)
                    setTour(res?.data?.data?.tour)
                    setComputedPricing(res?.data?.data?.computed_pricing)
                    setHotelDetails(res?.data?.data?.hotels)
                    setAllTransport(res?.data?.data?.transports);
                    setTransport(res?.data?.data?.displays?.transport);
                    setTransportData(res?.data?.data?.transport_schedule);
                    setHotelData(res?.data?.data?.displays?.hotel);
                    setRooms(res?.data?.data?.rooms);
                    setCustomer(res?.data?.data?.customer);
                    setImg(res?.data?.data?.package?.featured_photo || hotelImg);
                    const hoteldata = res?.data?.data?.tour?.hotel_data_raw;
                    const transportdata = res?.data?.data?.tour?.transport_data_raw;

                    try {
                        setHotelPrice(hoteldata ? hoteldata : null);
                    } catch (e) {
                        console.error("Invalid hotel_data JSON:", hoteldata, e);
                        setHotelPrice(null);
                    }

                    try {
                        setTransportPrice(transportdata ? transportdata : null);
                    } catch (e) {
                        console.error("Invalid transport_data JSON:", transportdata, e);
                        setTransportPrice(null);
                    }




                }


            } catch (err) {
                console.log(err)
            } finally {
                setTimeout(() => setLoading(false), 7000);
            }
        }
        fetchItinerary_wrt_id();

    }, [custId, destinationId, tourId])
    const printRef = useRef();
    const printFunction = useReactToPrint({
        contentRef: printRef,
        documentTitle: "Tour PDF",
    });

    const waitForImages = async (element) => {
        const images = element.querySelectorAll("img");
        await Promise.all(
            [...images].map(
                img =>
                    img.complete
                        ? Promise.resolve()
                        : new Promise(resolve => {
                            img.onload = resolve;
                            img.onerror = resolve;
                        })
            )
        );
        return new Promise(resolve => setTimeout(resolve, 800));
    };


    const handleDownloadPDF = async () => {
        console.log("button clicked")
        const element = printRef.current;

        const options = {
            margin: [0.4, 0.4, 0.4, 0.4], // top right bottom left
            filename: "Tour-Itinerary.pdf",
            image: { type: "jpeg", quality: 0.98 },

            html2canvas: {
                scale: 2,
                useCORS: true,
                allowTaint: false,
                letterRendering: true,
                scrollY: 0,
            },

            jsPDF: {
                unit: "in",
                format: "a4",
                orientation: "portrait",
            },

            pagebreak: {
                mode: ["css", "legacy"],

                avoid: [
                    ".itinerary-day-box",
                    ".itinerary-transport-box",
                    ".itinerary-quotation-box",
                    "table",
                    "img"
                ]
            }
        };



        await waitForImages(element);

        html2pdf().set(options).from(element).save();
    };


    console.log("hotelPrice", hotelPrice)
    console.log("transportPrice", transportPrice)

    let totalAdult = 0;
    let totalChild = 0;
    let totalInfant = 0;

    if (hotelPrice && typeof hotelPrice === "object") {
        Object.values(hotelPrice).forEach(item => {
            totalAdult += Number(item.adult_price || 0);
            totalChild += Number(item.child_price || 0);
            totalInfant += Number(item.infant_price || 0);
        });
    }

    let groupedTotals = {};

    if (transportPrice && typeof transportPrice === "object") {
        Object.values(transportPrice).forEach(arr => {
            if (Array.isArray(arr)) {
                arr.forEach(item => {
                    const id = item.transport_id;
                    const base = Number(item.base_price || 0);
                    const extra = Number(item.extra_price || 0);

                    if (!groupedTotals[id]) {
                        groupedTotals[id] = { baseTotal: 0, extraTotal: 0, grandTotal: 0 };
                    }

                    groupedTotals[id].baseTotal += base;
                    groupedTotals[id].extraTotal += extra;
                    groupedTotals[id].grandTotal += base + extra;
                });
            }
        });
    }

    const totalTransportAmount = Object.values(groupedTotals).reduce(
        (sum, item) => sum + item.grandTotal,
        0
    );

    console.log("Total Transport Amount:", totalTransportAmount);
    const mealPlan = rooms.map(room => {
        const meals = [];
        if (room.breakfast) meals.push("Breakfast");
        if (room.lunch) meals.push("Lunch");
        if (room.dinner) meals.push("Dinner");

        return meals.length > 0 ? meals.join(" + ") : "";
    });


    const groupData = tour?.dates?.group|| null;

    return (
        <>
            <div ref={printRef} className="itinerary-container pdf-watermark" >
                {/* Cover / Welcome */}
                <section className="itinerary-page ">
                    <span style={{ display: "flex", justifyContent: "center" }}><img src={logo} width="150px" height="150px" /></span>

                    <p className="itinerary-welcome">
                        <div className="namaste-wrapper">
                            <span className="namaste-icon">🙏</span>
                            <span className="namaste-text">Namaste!</span>
                            <span className="namaste-icon">🙏</span>
                        </div>
                        <span>You're warmly welcomed to Jayraj Group, where we're dedicated
                            to making your spiritual journey to Kedarnath and Badrinath Dham truly
                            unforgettable. This sacred pilgrimage is a perfect blend of devotion,
                            spiritual growth, and breathtaking natural beauty, promising a
                            life-enriching experience.</span>

                    </p>
                    <div style={{ marginTop: "150px", maxWidth: "700px" }}>
                        <img src={pdfhomeimg} width="100%" style={{ borderRadius: "10px" }} />
                    </div>

                </section>

                {/* Package Details */}
                <section className="itinerary-page ">
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <h2 className="itinerary-heading">Package Details</h2>
                        <img src={logo} alt="Jayraj Group Logo" className="itinerary-logo" />

                    </div>

                    <table className="itinerary-details">
                        <tbody>
                            <tr><td>Name</td><td>{customer?.name}</td></tr>
                            <tr><td>Tour ID</td><td>CP{tour?.id || "N/A"}</td></tr>
                            <tr><td>Phone No.</td><td>{customer?.mobile}</td></tr>
                            <tr><td>Whatsapp No.</td><td>{customer?.whatsapp_no}</td></tr>
                            <tr><td>Email ID</td><td>{customer?.email}</td></tr>
                            <tr><td>Address</td><td>{customer?.address}</td></tr>
                            <tr><td>Package</td><td>{tour?.trip_type_name}</td></tr>
                            {tour?.extra_details?.room && <tr><td>Room Type</td><td>{tour?.extra_details?.room}</td></tr>}
                         {tour?.extra_details?.facility.length >0 &&  <tr><td>Facilities</td><td>                                        {tour?.extra_details?.facility.map((fac) => (
                                           
                                                <span>{fac.name}, </span>
                                            
                                        ))}</td></tr> } 
                           {tour?.extra_details?.transport?.name &&  <tr><td>Transport</td><td>{tour?.extra_details?.transport?.name}
                                {tour?.extra_details?.transport?.ac_type && ` (${tour?.extra_details?.transport?.ac_type})`}</td></tr>}
                            <tr><td>Travel Dates</td><td>              {tour?.dates?.range?.start && tour?.dates?.range?.end
                                ? `${formatDate(tour.dates?.range?.start)} to ${formatDate(tour.dates?.range?.end)}`
                                : "Not Available"}</td></tr>
                            {/* <tr>
                            <td>Meal Plan</td>
                            <td>
                                Breakfast/Lunch/Dinner
                            </td>
                        </tr>
                        <tr><td>Room Category</td><td>

                            Standard/Semi Deluxe/Deluxe

                        </td></tr> */}
                            <tr><td>Duration</td><td>{itinerary.length} Days {itinerary.length - 1} Nights</td></tr>
                            {/* <tr><td>Number of Rooms</td><td>{computedPricing?.persons?.rooms_requested || 0}</td></tr> */}
                            <tr>
                                <td>Guest Count</td>
                                <td>
                                    {tour?.trip_type_id === 5 || tour?.trip_type_id === 3 ? (
                                        <>
                                            {adultCount || 1} Adult{" "}
                                            {childCount || 0} Child{" "}

                                        </>
                                    ) : (
                                        <>
                                            {computedPricing?.persons?.adult || 0} Adult{" "}
                                            {computedPricing?.persons?.child || 0} Child

                                        </>
                                    )}
                                </td>
                            </tr>

                        </tbody>
                    </table>
                    <span style={{ display: "flex", justifyContent: "center" }}><img src={packageImgpdf} width="100%" height="350px" /></span>
                </section>

{/* Tour Details */}
<section className="itinerary-page ">
    <div className="itinerary-destination-header">
        <h4 className="itinerary-heading"><strong>Tour Details</strong></h4>
        <img
            src={logo}
            alt="Jayraj Group Logo"
            className="itinerary-logo"
        />
    </div>

    {/* Image */}
    <div className="itinerary-photo-wrapper">
        <img
            src={`${tour?.images?.find(img => img.is_featured)?.url || img}`}
            alt="Haridwar"
            className="itinerary-photo"
            crossOrigin="anonymous"
        />
    </div>

    {/* Overview Box */}
    <div className="itinerary-overview-box">
        <p className="itinerary-overview-title">{tour?.title}:</p>
        <p className="itinerary-overview-text">
            {sanitizeToText(tour?.description || "")}
        </p>
    </div>


</section>
{/* Available Dates Section */}
<section className="itinerary-page ">
        {/* Available Dates Section */}
    {groupData && groupData.departure_dates && groupData.departure_dates.length > 0 && (
        <AvailableDatesSection groupData={groupData} />
    )}
</section>

                {/* Brief Itinerary */}
                <section className="itinerary-page ">
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <h2 className="itinerary-heading">Breif Itinerary</h2>
                        <img src={logo} alt="Jayraj Group Logo" className="itinerary-logo" />
                    </div>
                    <div style={{ fontSize: "1.3rem", fontWeight: "bold", color: "#503507", textAlign: "center" }}>{itinerary[0]?.name}</div>
                    {itinerary?.map((item, index) => {
                        // Base date = tour_start_date from your API
                        const baseDate = new Date(tour?.tour_start_date);

                        // Add days according to index (Day 1 = +0, Day 2 = +1, etc.)
                        const currentDate = new Date(baseDate);
                        currentDate.setDate(baseDate.getDate() + index);

                        // ✅ Correct way to get today's transports
                        // const todayTransports = transport?.[item.day] || [];



                        const inputData = transportData?.Basic || {};

                        const output = Object.entries(inputData).reduce((acc, [day, transports]) => {
                            acc[day] = transports;
                            return acc;
                        }, {});

                        console.log("output", output);
                        const todayTransports = (transport?.[item.day] || []).map(t => {
                            const qtyData = output?.[item.day]?.find(
                                x => x.transport_id === t.transport_id
                            );

                            const qty = qtyData?.qty || 0;

                            const lineTotal =
                                (t.base_price +
                                    t.extra_price +
                                    (t.km || 0) * (t.per_km || 0)) * qty;

                            return {
                                ...t,
                                qty,
                                line_total: lineTotal,
                            };
                        });


                        const todayHotels = hotelData?.Basic?.[item.day] || [];
                        const todayHotelsPremium = hotelData?.Premium?.[item.day] || [];
                        const todayHotelsStandard = hotelData?.Standard?.[item.day] || [];
                        console.log("Today hotel for Day ", item.day, ": ", todayHotels);

                        const groupHotel = hotelData?.[item.day] || [];





                        return (
                            <div key={index} className="itinerary-day-box no-break">

                                <div className="itinerary-day-header">
                                    <span className="itinerary-day-title">Day - {item?.day}</span>
                                    <span className="itinerary-day-title">{item?.date}</span>

                                    {/* {currentDate && !isNaN(new Date(currentDate)) ? formatDate(currentDate) : ""} */}
                                </div>


                                {/* Plans */}
                                <div className="itinerary-plan">
                                    <p className="itinerary-place">{item?.title}</p>
                                    <p className="itinerary-note" style={{ textAlign: "justify" }}>
                                        {sanitizeToText(item?.description || "")}
                                    </p>
                                </div>
                                <div className='hotel_transport_same_page'>
                                    {/* group tour Hotels  */}
                                    {groupHotel?.base_price && (
                                        <div className="itinerary-transport-box">
                                            <h4>Hotel</h4>

                                            <div className="itinerary-transport-card hotel-card" style={{ display: "flex", justifyContent: "space-between" }}>

                                                <div>
                                                    <a href={`https://jayrajgroup.org/hotel/${groupHotel?.hotel_id}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"

                                                        className="pdf-link"><strong>{groupHotel?.hotel_name}</strong></a>
                                                    <p>Room: {groupHotel?.room_name || "Base Accommodation"}</p>
                                                    <p>Base Price: {groupHotel?.base_price}</p>
                                                    {groupHotel?.capacity && <p>Max-Capacity: {groupHotel?.capacity}</p>}
                                                    <p>Extra Adult: ₹{groupHotel?.adult_price}</p>
                                                    <p>Extra Child: ₹{groupHotel?.child_price}</p>
                                                </div>
                                                <div >
                                                    <img src={groupHotel?.hotel_image || noimg} alt="Hotel" height="130px" width="200px" style={{ borderRadius: "10px" }} crossOrigin="anonymous" />
                                                </div>

                                            </div>

                                        </div>
                                    )}

                                    {/* ✅ Hotels for this day */}
                                    {todayHotels?.base_price && (
                                        <div className="itinerary-transport-box">
                                            <h4>Hotel(Basic)</h4>

                                            <div className="itinerary-transport-card hotel-card" style={{ display: "flex", justifyContent: "space-between" }}>

                                                <div>
                                                    <a href={`https://jayrajgroup.org/hotel/${todayHotels?.hotel_id}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="pdf-link"><strong>{todayHotels?.hotel_name}</strong></a>
                                                    <p>Room: {todayHotels?.room_name || "Base Accommodation"}</p>
                                                    <p>Base Price: {todayHotels?.base_price}</p>
                                                    {computedPricing?.persons?.rooms_requested !== 0 ? <p>Number of Rooms: {computedPricing?.persons?.rooms_requested}</p> : ""}
                                                    {todayHotels?.capacity && <p>Max-Capacity: {todayHotels?.capacity}</p>}
                                                    <p>Extra Adult: ₹{todayHotels?.adult_price}</p>
                                                    <p>Extra Child: ₹{todayHotels?.child_price}</p>
                                                </div>
                                                <div >
                                                    <img src={todayHotels?.hotel_image || noimg} alt="Hotel" height="130px" width="200px" style={{ borderRadius: "10px" }} />
                                                </div>

                                            </div>

                                        </div>
                                    )}
                                    {todayHotelsStandard?.base_price && (
                                        <div className="itinerary-transport-box">
                                            <h4>Hotel(Standard)</h4>

                                            <div className="itinerary-transport-card hotel-card" style={{ display: "flex", justifyContent: "space-between" }}>

                                                <div>
                                                    <p onClick={() => window.open(`https://jayrajgroup.org/hotel/${todayHotelsStandard?.hotel_id}`)} style={{ textDecoration: "underline", cursor: "pointer" }}><strong>{todayHotelsStandard?.hotel_name}</strong></p>
                                                    <p>Room: {todayHotelsStandard?.room_name || "Standard Accommodation"}</p>
                                                    <p>Base Price: {todayHotelsStandard?.base_price}</p>
                                                    {computedPricing?.persons?.rooms_requested !== 0 ? <p>Number of Rooms: {computedPricing?.persons?.rooms_requested}</p> : ""}
                                                    {todayHotelsStandard?.capacity && <p>Max-Capacity: {todayHotelsStandard?.capacity}</p>}
                                                    <p>Extra Adult: ₹{todayHotelsStandard?.adult_price}</p>
                                                    <p>Extra Child: ₹{todayHotelsStandard?.child_price}</p>
                                                </div>
                                                <div >
                                                    <img src={todayHotelsStandard?.hotel_image || noimg} alt="Hotel" height="130px" width="200px" style={{ borderRadius: "10px" }} />
                                                </div>

                                            </div>

                                        </div>
                                    )}
                                    {todayHotelsPremium?.base_price && (
                                        <div className="itinerary-transport-box">
                                            <h4>Hotel(Premium)</h4>

                                            <div className="itinerary-transport-card hotel-card" style={{ display: "flex", justifyContent: "space-between" }}>

                                                <div>
                                                    <p onClick={() => window.open(`https://jayrajgroup.org/hotel/${todayHotelsPremium?.hotel_id}`)} style={{ textDecoration: "underline", cursor: "pointer" }}><strong>{todayHotelsPremium?.hotel_name}</strong></p>
                                                    <p>Room: {todayHotelsPremium?.room_name || "Premium Accommodation"}</p>
                                                    <p>Base Price: {todayHotelsPremium?.base_price}</p>
                                                    {computedPricing?.persons?.rooms_requested !== 0 ? <p>Number of Rooms: {computedPricing?.persons?.rooms_requested}</p> : ""}
                                                    {todayHotelsPremium?.capacity && <p>Max-Capacity: {todayHotelsPremium?.capacity}</p>}
                                                    <p>Extra Adult: ₹{todayHotelsPremium?.adult_price}</p>
                                                    <p>Extra Child: ₹{todayHotelsPremium?.child_price}</p>
                                                </div>
                                                <div >
                                                    <img src={todayHotelsPremium?.hotel_image || noimg} alt="Hotel" height="130px" width="200px" style={{ borderRadius: "10px" }} />
                                                </div>

                                            </div>

                                        </div>
                                    )}




                                    {/* ✅ Transports for this day */}
                                    {todayTransports.length > 0 && (
                                        <div className="itinerary-transport-box">
                                            <h4>Transport</h4>

                                            {todayTransports.map((t, tIndex) => (
                                                <div key={tIndex} className={`itinerary-transport-card ${tIndex % 2 === 1 ? "hotel-card" : "transport-card"
                                                    }`} style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <div>
                                                        <p><strong>{t.transport_name}</strong> ({t.ac_type})</p>
                                                        <p>Capacity: {t.capacity}</p>
                                                        {t.qty !== 0 ? <p>Quantity: {t.qty}</p> : ""}
                                                        <p>Base Price: ₹{t.base_price}</p>
                                                        <p>Per KM Price: ₹{t.per_km}</p>
                                                        <p>Extra Price: ₹{t.extra_price}</p>
                                                    </div>
                                                    <div >
                                                        <img
                                                            src={t?.transport_image ? `${t.transport_image}?t=${new Date().getTime()}` : noimg}
                                                            alt="Transport"
                                                            height="130px"
                                                            width="200px"
                                                            style={{ borderRadius: "10px" }}
                                                            crossOrigin="anonymous"
                                                        />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                            </div>
                        );
                    })}

                </section>

                {/* Destination Example */}
                <section className="itinerary-page ">
                    <div className="itinerary-destination-header">
                        <span className="itinerary-heading"><strong>Destination</strong>: {tour?.destination?.name}</span>
                        <img
                            src={logo}
                            alt="Jayraj Group Logo"
                            className="itinerary-logo"
                        />
                    </div>

                    {/* Image */}
                    <div className="itinerary-photo-wrapper">
                        <img
                            src={tour?.destination?.featured_photo
                                ? `${tour.destination.featured_photo}?t=${new Date().getTime()}`
                                : img
                            }
                            alt={tour?.destination?.name || "Destination"}
                            className="itinerary-photo"
                            crossOrigin="anonymous"
                        />
                    </div>

                    {/* Overview Box */}
                    <div className="itinerary-overview-box">
                        <p className="itinerary-overview-title">Overview:</p>
                        <p className="itinerary-overview-text">
                            {sanitizeToText(tour?.destination?.description || "")}
                        </p>
                        <div style={{ display: "flex", justifyContent: 'center' }}>

                            <a
                                href={`https://jayrajgroup.org/destination-images/${tour?.destination?.id}`}
                                target="_blank"
                                className="itinerary-btn"
                            >
                                View more images
                            </a>

                        </div>

                    </div>
                </section>

                {/* hotel details */}

                {/* <section className="itinerary-page">
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <h2 className="itinerary-heading">Breif Hotels</h2>
                    <img src={logo} alt="Jayraj Group Logo" className="itinerary-logo" />
                </div>

                {hotelDetails?.map((hotel, index) => (
                    <div key={index} className="pdf-hotel-card">
                        <div className="pdf-hotel-header">
                            <img
                                src={`https://admin.jayrajgroup.com/uploads/hotels/gallery/${hotel.featured_image}`}
                                alt={hotel.name}
                                className="pdf-hotel-image"
                            />
                            <div className="pdf-hotel-info">
                                <h3>{hotel.name}</h3>
                                <p className="pdf-hotel-location">{hotel.location}</p>
                                <p className="pdf-hotel-landmark">Landmark: {hotel.land_mark}</p>
                                <div className="pdf-hotel-description">
                                    {sanitizeToText(hotel.description || "")}
                                </div>

                            </div>
                        </div>

                      
                        {hotel.gallery?.length > 0 && (
                            <div className="pdf-hotel-gallery">
                                {hotel.gallery.slice(0, 4).map((g, i) => (
                                    <img key={i} src={g} alt={`gallery-${i}`} />
                                ))}
                            </div>
                        )}

                   
                        <div className="pdf-hotel-rooms">
                            <h4>Rooms</h4>
                            {hotel.rooms?.map((room, rIndex) => (
                                <div key={rIndex} className="pdf-hotel-room">
                                    <img
                                        src={room.featured_image}
                                        alt={room.name}
                                        className="pdf-room-image"
                                    />
                                    <div className="pdf-room-info">
                                        <h5>{room.name}</h5>
                                        <p>Type: {room.room_type}</p>
                                        <p>Max Guests: {room.max_guests}</p>
                                        <p>Fooding: {room.fooding}</p>
                                        <p>Price/Night: ₹{room.price_per_night}</p>
                                        <div>{sanitizeToText(room.description || "")}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </section> */}

                {/* Quotation */}
                <section className="itinerary-page ">
                    <div className="itinerary-destination-header">
                        <h2 className="itinerary-heading">Quotation</h2>
                        <img src={logo} alt="Jayraj Group Logo" className="itinerary-logo" />
                    </div>

                    {/* Quotation Box */}
                    <div className="itinerary-quotation-box">
                        {/* <div className="itinerary-quotation-row">
                        <span>No. of Paying Person</span>
                        <span>No. of Adult + No. of Child</span>
                    </div> */}
                        {tour?.trip_type_id === 5 ? (<div>
                            <div className="itinerary-quotation-row">
                                <span>Per Adult</span>
                                <span>₹ {tour?.pricing?.stored_totals?.total_price} /-</span>
                            </div>
                            <div className="itinerary-quotation-row">
                                <span>Adult Count</span>
                                <span>{adultCount}</span>
                            </div>
                            {childCount > 0 &&
                                <>

                                    <div className="itinerary-quotation-row">
                                        <span>Per Child</span>
                                        <span>₹ {groupResponse?.computed_totals?.child_extra || 0} /-</span>
                                    </div>
                                    <div className="itinerary-quotation-row">
                                        <span>Child Count</span>
                                        <span>{childCount || 0}</span>
                                    </div>
                                </>
                            }

                            <div className="itinerary-quotation-row">
                                <span style={{ fontSize: "1rem", fontWeight: "800" }}>Total Price</span>
                                {/* <span style={{ fontSize: "1rem", fontWeight: "600" }}>₹ {(tour?.pricing?.stored_totals?.total_price)*((tour?.counts?.adult+ tour?.counts?.child) || (computedPricing?.persons?.adult + computedPricing?.persons?.child))} /-</span> */}
                                <span style={{ fontSize: "1rem", fontWeight: "800" }}>₹ {(tour?.pricing?.stored_totals?.total_price * adultCount) + (groupResponse?.computed_totals?.child_extra * childCount)} /-</span>
                            </div>
                        </div>) :
                            <div>
                                <span style={{ fontSize: "1.2rem", fontWeight: "700" }}>Basic</span>
                                <div className="itinerary-quotation-row">
                                    <span>Per Person</span>
                                    <span>{computedPricing?.per_person?.basic ? "₹ " + computedPricing?.per_person?.basic + " /-" : "NA"}</span>
                                </div>
                                <div className="itinerary-quotation-row">
                                    <span>Total Price</span>
                                    <span>
                                        {computedPricing?.per_person?.basic
                                            ? tour?.trip_type_id === 3
                                                ? `₹ ${(computedPricing.per_person.basic * adultCount).toLocaleString()} /-`
                                                : `₹ ${tour?.pricing?.stored_totals?.total_price_basic.toLocaleString()} /-`
                                            : "NA"}
                                    </span>


                                </div>
                                <span style={{ fontSize: "1.2rem", fontWeight: "700" }}>Standard</span>
                                <div className="itinerary-quotation-row">
                                    <span>Per Person</span>
                                    <span>{computedPricing?.per_person?.standard ? "₹ " + computedPricing?.per_person?.standard + " /-" : "NA"}</span>
                                </div>
                                {

                                }
                                <div className="itinerary-quotation-row">
                                    <span>Total Price</span>
                                    <span>
                                        {computedPricing?.per_person?.standard
                                            ? tour?.trip_type_id === 3
                                                ? `₹ ${(computedPricing.per_person.standard * adultCount).toLocaleString()} /-`
                                                : `₹ ${tour?.pricing?.stored_totals?.total_price_standard.toLocaleString()} /-`
                                            : "NA"}
                                    </span>
                                </div>
                                <span style={{ fontSize: "1.2rem", fontWeight: "700" }}>Premium</span>
                                <div className="itinerary-quotation-row">
                                    <span>Per Person</span>
                                    <span>{computedPricing?.per_person?.premium ? "₹ " + computedPricing?.per_person?.premium + " /-" : "NA"}</span>
                                </div>
                                <div className="itinerary-quotation-row">
                                    <span>Total Price</span>
                                    <span>
                                        {computedPricing?.per_person?.premium
                                            ? tour?.trip_type_id === 3
                                                ? `₹ ${(computedPricing.per_person.premium * adultCount).toLocaleString()} /-`
                                                : `₹ ${tour?.pricing?.stored_totals?.total_price_premium.toLocaleString()} /-`
                                            : "NA"}
                                    </span>
                                </div>
                            </div>
                        }
                    </div>
                    {/* <div className="itinerary-quotation-row">
                        <span>Itinerary</span>
                        <span>- Rs _____/-</span>
                    </div>
                    <div className="itinerary-quotation-row">
                        <span>No. of Adult</span>
                        <span>{tour?.adult_count}</span>
                    </div> */}

                    {/* <hr className="itinerary-divider" />

                    <div className="itinerary-quotation-row total">
                        <span>Total Price</span>
                        <span>- Rs {tour?.pricing?.stored_totals?.total_price} /-</span>
                    </div>
                </div> */}

                    {/* Vehicle Table */}
                    {/* <section className="itinerary-quotation-box">
                    {/* <h3 className="itinerary-subheading">Vehicle</h3>
                    <table className="itinerary-details">
                        <thead>
                            <tr>
                                <th>Type</th>
                                <th>Capacity</th>
                                <th>Pickup/Drop</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{transport?.type}({transport?.ac_type})</td>
                                <td>{transport?.capacity}</td>

                                <td>{transport?.points?.map((point) => {
                                    if (point?.type === "boarding")
                                        return `${point?.location}/`
                                    else {
                                        return `${point?.location}`
                                    }
                                }
                                )}</td>
                            </tr>
                        </tbody>
                    </table> */}
                    {/* Button */}
                    {/* <div style={{ display: "flex", justifyContent: 'center' }}>
                        <button className="itinerary-btn">Add Pilgrim Details</button>
                    </div> */}


                    {/* </section> */}


                    {/* Illustration */}

                    <span style={{ display: "flex", justifyContent: "center", marginTop: "170px" }}><img src={vahicle} width="100%" height="100%" /></span>


                </section>

                {/* Terms & Conditions */}
                <section className="itinerary-page ">
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <h2 className="itinerary-heading">Terms & Conditions</h2>
                        <img src={logo} alt="Jayraj Group Logo" className="itinerary-logo" />
                    </div>

                    <div className="itinerary-overview-box">
                        <SafeMap mapHtml={tour?.terms_conditions} />
                        {/* {sanitizeToText(tour?.terms_conditions || "")} */}
                    </div>
                </section>


                <section className="itinerary-page itinerary-footer ">
                    {/* Logo */}
                    <div className="footer-logo">
                        <img src={logo} alt="Jayraj Group Logo" />
                        <h3>JAYRAJ GROUP</h3>
                    </div>

                    {/* Contact Info */}
                    <div className="footer-contacts">
                        <div>
                            <p>+91-8869872377</p>
                            <p>+91-8954446577</p>
                        </div>
                        <div>
                            <p>info@jayrajgroup.org</p>
                            <p>www.jayrajgroup.org</p>
                        </div>
                    </div>

                    {/* Social Icons */}
                    <div className="footer-social">
                        <p>Visit Us</p>
                        <div className="footer-icons">

                            <FaWhatsapp />
                            <FaYoutube />
                            <FaInstagram />
                            <FaFacebook />
                        </div>
                    </div>

                    {/* Office Info */}
                    <div className="footer-office">
                        <p>
                            <strong>Corporate Office</strong><br />
                            Semi Talli Ukhimath Kedarnath Road, Rudraprayag Kedarnath, Uttarakhand-246439, India.
                        </p>
                        <p>
                            GST : 05BFVPJ3757G1Z2 &nbsp;&nbsp; | &nbsp;&nbsp; UDYAM : UDYAM-UK-10-0004280
                        </p>
                    </div>
                </section>





            </div>
            {/* Print Button */}
            <button onClick={handleDownloadPDF} className="itinerary-print-btn">
                <FaDownload style={{ marginRight: "8px" }} />
                Download
            </button>
        </>

    )
}

export default ItineryFinal